export default __webpack_public_path__ + "static/media/7photo(new).ad890d49.jpg";